import { InitState } from '../../../../../redux/reducers/root/initialState'
import {
  manuallyEditDescription,
  manuallyEditLocation,
  manuallyEditTitle,
} from '../../../../../redux/reducers/suggestedText/suggestedTextFeature'
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks'

export const useSuggestion = (enabledHook: boolean) => {
  const dispatch = useAppDispatch()
  const {
    isLocationManuallyEdited,
    isDescriptionManuallyEdited,
    isTitleManuallyEdited,
    suggestedTitle,
    suggestedDescription,
    suggestedLocation,
  } = useAppSelector((state: InitState) => state.suggestedTextFeature)
  const showTitleSubtitle = !isTitleManuallyEdited && enabledHook && (suggestedTitle ?? '').length > 0
  const showDescriptionSubtitle = !isDescriptionManuallyEdited && enabledHook && (suggestedDescription ?? '').length > 0
  const showLocationSubtitle = !isLocationManuallyEdited && enabledHook && (suggestedLocation ?? '').length > 0

  const onHandleTitleChange = () => enabledHook && !isTitleManuallyEdited && dispatch(manuallyEditTitle())
  const onHandleDescriptionChange = () =>
    enabledHook && !isDescriptionManuallyEdited && dispatch(manuallyEditDescription())
  const onHandleLocationChange = () => enabledHook && !isLocationManuallyEdited && dispatch(manuallyEditLocation())

  return {
    showTitleSubtitle,
    showDescriptionSubtitle,
    showLocationSubtitle,
    onHandleTitleChange,
    onHandleDescriptionChange,
    onHandleLocationChange,
  }
}
